// /* eslint-disable @typescript-eslint/no-explicit-any */
export type Layout = {
  title: string;
  uniqueId: string;
  components?: Component[] | VariationContainer[];
};

export type TextItem = {
  fields: {
    text: string;
    uniqueId: string;
  };
};

export type VariationContainer = {
  fields: {
    experimentId: string;
    experimentKey: string;
    experimentTitle: string;
    meta: Record<string, string>;
    variations?: Component[];
  };
};

export type BaseComponent = {
  sys: {
    contentType: {
      sys: {
        id: string;
      };
    };
  };
};

export type BaseComponentFields = {
  id: string;
  internalName: string;
};

export type OneAuthEntry = {
  analyticsId: string;
  components?: Component[];
} & BaseComponentFields;

export type Component = {
  fields: {
    description: string;
    uniqueId: string;
    textItems?: TextItem[];
    oneAuthProps?: Record<string, any>;
    valuePropsProps?: Record<string, any>;
    analyticsId: string;
    components?: Component[] | TextComponent[];
    experimentId?: string;
    experimentKey?: string;
    experimentTitle?: string;
    meta: Record<string, string>;
    variations: Component[] | TextComponent[];
  };
  sys: Record<string, any> & {
    id: string;
    locale: string;
  } & BaseComponentFields;
} & BaseComponent;

export type TextComponent = {
  fields: {
    experimentId?: string;
    experimentKey?: string;
    experimentTitle?: string;
    variations?: {
      fields: {
        id: string;
        internalName: string;
        value: string;
      };
      metaData: {
        tags: string[];
      } & BaseComponent;
    }[];
    meta?: Record<string, string>;
    value: string;
  } & BaseComponentFields;
} & BaseComponent;

export const enabledLocales = [
  'en-US',
  'es-MX',
  'ar-SA',
  'ar-AE',
  'tr-TR',
  'en',
  'es-419',
  'tr',
  'es',
  'en-IN',
  'ko',
  'en-GB',
  'tr-tr',
  'tr-Tr',
] as const;
export const DEFAULT_LOCALE = 'en-US';

export type Locale = typeof enabledLocales[number];

export const AUTH_OPTIMIZELY_EXPERIMENT_ID = 'chrome_localisation_phase1';

export const LOCALISED_VARIATION_ID = 'Localised';

export type TextCompType = {
  fields: {
    variations: {
      fields: {
        id: string;
        internalName: string;
        value: string;
      };
      metaData: {
        tags: string[];
      };
      sys: {
        id: string;
      };
    }[];
    experimentKey: string | undefined;
    meta: { [x: string]: any };
  };
};

export type OFSParams = {
  experimentId: string;
  variationId: string;
}[];

export type OFSParamsObj = {
  experimentId: string;
  variationId: string;
};

export const LANG_PREFERENCE_COOKIE = 'langPreference';
